var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"mini-basket\" ng-click=\"$miniBasketCtrl.scrollToBasket();\">\n<i class=\"fa\" style=\"font-size:24px\">&#xf07a;</i>\n<span class=\"badge badge-warning\" id=\"lblCartCount\"> {{$miniBasketCtrl.basket.length}} </span>\n</div>\n";
var id1="javascripts/basket/mini-basket/mini_basket.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../src/public/javascripts/basket/mini-basket/mini_basket.template.html
// module id = 1291
// module chunks = 0